/** 모든 조회 기간의 주문 토큰에 고정 6 Luna 단가를 적용한 추정 비용. */
export const KRW_EXCHANGE_RATE = 1400;
const INPUT_USD_PER_MILLION = 0.1;
const OUTPUT_USD_PER_MILLION = 0.5;

export interface OrderCost {
  totalCount: number;
  confirmDt?: string;
  totalPromptToken?: number;
  totalCompletionToken?: number;
}

export const costInKrw = (cost: OrderCost): number | null => {
  const input = cost.totalPromptToken ?? 0;
  const output = cost.totalCompletionToken ?? 0;
  if (!Number.isFinite(input) || !Number.isFinite(output) || input < 0 || output < 0) return null;
  return ((input * INPUT_USD_PER_MILLION + output * OUTPUT_USD_PER_MILLION)
    / 1_000_000) * KRW_EXCHANGE_RATE;
};

export const averageCost = (cost: number | null, count: number): number | null =>
  cost === null ? null : count > 0 ? cost / count : 0;

export const sumCosts = (orders: OrderCost[]): number | null => {
  let total = 0;
  for (const order of orders) {
    const cost = costInKrw(order);
    if (cost === null) return null;
    total += cost;
  }
  return total;
};

export const formatCost = (cost: number | null): string =>
  cost === null ? '—' : Math.round(cost).toLocaleString('ko-KR');
